import type { PostChannelMoveOption } from "@/features/study-group-stream/types/postChannelMove";

export interface PostCardMoveChannelSections {
  home?: PostChannelMoveOption;
  channels: PostChannelMoveOption[];
  adminOnly: PostChannelMoveOption[];
  archives: PostChannelMoveOption[];
  archivesAdminOnly: PostChannelMoveOption[];
}

export const buildPostCardMoveChannelSections = (
  movableChannels: PostChannelMoveOption[],
): PostCardMoveChannelSections => {
  const home = movableChannels.find((channel) => channel.kind === "home");
  const topics = movableChannels.filter((channel) => channel.kind === "topic");

  return {
    home,
    channels: topics.filter(
      (channel) => !channel.isAdminOnly && !channel.isArchived,
    ),
    adminOnly: topics.filter(
      (channel) => channel.isAdminOnly && !channel.isArchived,
    ),
    archives: topics.filter(
      (channel) => !channel.isAdminOnly && channel.isArchived,
    ),
    archivesAdminOnly: topics.filter(
      (channel) => channel.isAdminOnly && channel.isArchived,
    ),
  };
};
